import React, {useContext, useState} from 'react';
import {CssBaseline} from '@mui/material';
import CityPredictionTabs from '../Tabs/Tabs';
import CountyPredictionTabs  from '../CountyTabs/Tabs'
import PredictionTab from '../Tabs/PredictionTab';
import {authContext} from '../Context/Authentication/authContext';
import SideMenu from '../SideMenu/SideMenu';
import Clusters from '../Clusters/Clusters';
import Predictions from '../Predictions/Predictions';
import MsaPredictions from '../Predictions/MsaPredictions';
import HeatMap from '../HeatMap/HeatMap';
import WhatIfAnalysis from '../WhatIfAnalysis/WhatIfAnalysis';
import WhatIfMSA from '../WhatIfAnalysis/WhatIfMSA';
import WhatIfMulti from '../WhatIfAnalysis/WhatIfMulti';
import WarehouseSelection from '../WarehouseSelection/WarehouseSelection';
import MSATabs from '../MsaPreditions/MSATabs';
import './Home.scss';
import EconomicIndicators from '../EconomicIndicators/EconomicIndicators';
import Chat from '../Chat1/Chat';
import Draggable from 'react-draggable';
import {Resizable} from 're-resizable';

const Home = () => {
  const {state}: any = useContext(authContext);
  const [openChatWindow, setOpenChatWindow] = useState(false);

  const handleClose = () => {
    // setAnchorEl(null);
    setOpenChatWindow(false);
  };

  return (
    <>
      <div className='home-main'>
        <CssBaseline/>
        <SideMenu/>
        <main className='home-main__container'>
          {state?.filters?.city?.length > 0 ? (
            <div className='home-main__container__innerContent'>
              {state?.filters?.selectedType === 'predictedMetrics' ? (
                <CityPredictionTabs/>
              ) :  state?.filters?.selectedType === 'countyPredictedMetrics' ? (
                <CountyPredictionTabs/>
              ):state?.filters?.selectedType === 'cityClusters' ? (
                <Clusters/>
              ) : state?.filters?.selectedType === 'cityPredictions' ? (
                <Predictions/>
              ) 
             : state?.filters?.selectedType === 'countyPredictions' ? (
                <Predictions/>
              ) : state.filters?.selectedType === 'heatMap' ? (
                <HeatMap displayedRecords={state.filters?.heatmapTopRecords} dialog={false}/>
              ) : state.filters?.selectedType === 'zipcodePredictedMetrics' ? (
                <PredictionTab/>
              ) : state.filters?.selectedType === 'zipcodePredictions' ? (
                <Predictions/>
              ) : state.filters?.selectedType === 'whatIfAnalysis' ? (
                <WhatIfAnalysis/>
              ) : state.filters?.selectedType === 'whatIfAnalysis2' ? (
                <WhatIfMSA/>
              ) : state.filters?.selectedType === 'msaPredictedMetrics' ? (
                <MSATabs/>
              ) : state.filters?.selectedType === 'msaPredictions' ? (
                <MsaPredictions/>
              ) : state.filters?.selectedType === 'whatIfMulti' ? (
                <WhatIfMulti isMSA={false}/>
              ) : state.filters?.selectedType === 'whatIfMultiMSA' ? (
                <WhatIfMulti isMSA={true}/>
              ) : state.filters?.selectedType === 'warehouseSelection' ? (
                <WarehouseSelection/>
              ) : (
                <EconomicIndicators/>
              )}
            </div>
          ) : (
            <div className='home-main__container__noData'>
              No city selected !!!
            </div>
          )}
          <Draggable defaultClassName={!openChatWindow ? 'draggable-chat' : ''}>
            <Resizable
              defaultSize={{
                width: 512,
                height: '82%',
              }}
              className={
                openChatWindow
                  ? `swipeWrapper-container swipeWrapper-container__open`
                  : `swipeWrapper-container swipeWrapper-container__hidden`
              }
              style={{
                transition: openChatWindow ? 'none' : 'all 4s ease',
                zIndex: openChatWindow ? 9999 : 0,
                right: 0,
                position: 'absolute',
              }}
            >
              <div
                className={
                  openChatWindow
                    ? `swipeWrapper-container__innerContainer swipeWrapper-container__open`
                    : `swipeWrapper-container__innerContainer swipeWrapper-container__hidden`
                }
                style={{
                  // background: `url(${backgroundImage ? backgroundImage : bg})`,
                  transition: `all 2s ease`,
                  background: '#fff',
                }}
              >
                <Chat
                  selectedState={'chat'}
                  open={openChatWindow}
                  handleClose={handleClose}
                />
              </div>
            </Resizable>
          </Draggable>
          {!openChatWindow && (
            <div
              className='home-main__chatAIButtonContainer'
              onClick={() => setOpenChatWindow(true)}
            >
              <div className='home-main__chatAIButtonContainer__button'>AI</div>
            </div>
          )}
          {/* {(state?.user?.username?.toLowerCase() === 'senthil' ||
            state?.user?.username?.toLowerCase() === 'trevor') && (
            <IconButton
              style={{
                background: '#045e78',
                color: '#fff',
                position: 'absolute',
                right: 15,
                bottom: 15,
              }}
              className='icon-button'
              aria-describedby={id}
              onClick={handleClick}
            >
              <ChatIcon className='chat-icon'/>
            </IconButton>
          )} */}
        </main>
      </div>
    </>
  );
};

export default Home;